import '../styles/footer.css'
const Footer = ()=>{
    return(
    <footer>
        <h4>Contact</h4>
        <a className="btn btn-outline-light btn-floating m-1" href="https://github.com/Mubarek-Hassen/project-3-rick-and-morty" target="_blank" rel="noopener noreferrer" role="button"><i className="fab fa-github">GitHub</i></a>
         <br/>
         <a className="btn btn-outline-light btn-floating m-1" href="https://www.linkedin.com/in/mubarek-hassen-wubitu/" target="_blank" rel="noopener noreferrer" role="button"><i className="fab fa-linkedin-in">LinkedIn</i></a>
        <h4> Developed By Mubarek Hassen</h4>
        <h6> ⓒ 2022</h6>
    </footer>
    )
}

export default Footer